import {ChangeDetectorRef, Component, Input, OnInit, ViewChild} from '@angular/core';
import { SkypeService } from '../../page-skype/skype.service';
import { VkService } from '../../page-vk/vk.service';
import { TelegramService } from '../../page-telegram/telegram.service';
import { WhatsappService } from '../../page-whatsapp/whatsapp.service';
import { AllService } from '../../../services/all.service';
import { AllMessengersService } from '../all-messengers.service';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { NotifierWrapService } from '../../../services/notifier-wrap.service';
import {IMessengerConnector} from '../../../types/all.type';
import {FellowdeskService} from '../../page-fellowdesk/fellowdesk.service';
import {InterfaceService} from '../../../services/interface.service';
import {NgxModalDraggableDirective} from '../../../directives/draggable.directive';
import {log} from '../../../functions';


@Component({
  selector: 'app-modal-add-account',
  templateUrl: './modal-add-account.component.html',
  styleUrls: ['./modal-add-account.component.scss']
})
export class ModalAddAccountComponent implements OnInit {
  @Input() modalMode = false;
  arServicesAuthorized: IMessengerConnector[] = [];
  public modalDirective: NgxModalDraggableDirective;
  @ViewChild(NgxModalDraggableDirective)
  set setDirective(directive: NgxModalDraggableDirective) {
    log('setDirective', directive);
    this.modalDirective = directive;
  }
  constructor(
    public interfaceService: InterfaceService,
    public notifierWrapService: NotifierWrapService,
    public bsModalRef: BsModalRef,
    public skypeService: SkypeService,
    public vkService: VkService,
    public telegramService: TelegramService,
    public whatsappService: WhatsappService,
    public fellowdeskService: FellowdeskService,
    private cd: ChangeDetectorRef,
    public allService: AllService,
    public allMessengersService: AllMessengersService
  ) {}

  ngOnInit(): void {
    ///
    this.arServicesAuthorized = this.allMessengersService.arServicesNeedAuthorized();
    // log(this.arServicesAuthorized, '!!!!!!!!!!', this.allMessengersService.getServicesFilter('isAuth', false))
    ///
    if (this.arServicesAuthorized?.length > 0) {
      this.allMessengersService.active = this.arServicesAuthorized[0].type;
      this.interfaceService.setThemeColor(this.allMessengersService.active);
    }
    this.cd.detectChanges();
  }
  setActive(item) {
    this.notifierWrapService.playAudio('hover');
    this.allMessengersService.active = item.type;
    this.cd.detectChanges();
    this.interfaceService.setThemeColor(item.type);
  }
  hasType(type: string): boolean {
    return this.allMessengersService.active?.indexOf(type) > -1;
  }
}
